import { Loader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { ClientContractTermDetail } from '~/features/ClientContractTermDetail';
import { ClientContractTermDetailHeader } from '~/features/ClientContractTermDetailHeader';
import { getClientContractListLink } from '~/utils/getLinks';
import styles from './styles.module.scss';

/**
 * 企業契約期間 詳細 Screen
 *
 * - DetailHeader（パンくず・利用企業名表示）は ClientContractTermDetailHeader に委譲する
 * - 詳細 body は ClientContractTermDetail に委譲する
 * - clientId・termId はどちらもパスパラメータで受け取る
 * - NOTE: App.tsx の enableStaging フラグで gate されており、staging のみ表示される
 */
export const Screen: React.FC = () => {
  const { clientId, termId } = useParams<{ clientId: string; termId: string }>();

  const parsedClientId = Number.parseInt(clientId ?? '', 10);
  const parsedTermId = Number.parseInt(termId ?? '', 10);

  if (Number.isNaN(parsedClientId) || Number.isNaN(parsedTermId)) {
    return <Navigate to={getClientContractListLink()} replace />;
  }

  return (
    <>
      <Suspense fallback={<Loader />}>
        <ClientContractTermDetailHeader clientId={parsedClientId} termId={parsedTermId} />
      </Suspense>
      <main className={styles.body}>
        <Suspense fallback={<Loader />}>
          <ClientContractTermDetail clientId={parsedClientId} termId={parsedTermId} />
        </Suspense>
      </main>
    </>
  );
};
